(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nascr-ended-images"]) return;
  try {
    
  $(document).ready(function() {
    const swiper = new Swiper('.swiper-endedImages', {
        
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1.45,
          spaceBetween: 10
        },
        // when window width is >= 480px
        769: {
          slidesPerView: 2.35,
          spaceBetween: 10
        },
        // when window width is >= 640px
        1270: {
          slidesPerView: 2.35,
          spaceBetween: 10
        }
      },
      // 自动播放配置 - 无缝连续滑动效果
    autoplay: {
        delay: 0, // 极短延迟，配合速度实现无缝滑动
        disableOnInteraction: false, // 用户交互后继续自动播放
        pauseOnMouseEnter: false, // 鼠标悬停不暂停
        
    },
    speed: 8000, // 平滑过渡时间3秒（可调整，建议2000-5000之间）
    loop: true, // 无限循环
    loopAdditionalSlides: 2, // 循环时额外复制的幻灯片数量，让循环更流畅
    allowTouchMove: false, // 允许触摸滑动
    //   navigation: {
    //     nextEl: '.swiper-endedImages .swiper-button-next',
    //     prevEl: '.swiper-endedImages .swiper-button-prev',
    //   },
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nascr-highlights"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    const swiper = new Swiper('.swiper-hightlights', {
      loop: true,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2.2,
          spaceBetween: 10
        },
        // when window width is >= 480px
        769: {
          slidesPerView: 5,
          spaceBetween: 10
        },
        // when window width is >= 640px
        1270: {
          slidesPerView: 7.6,
          spaceBetween: 10
        }
      },
      navigation: {
        nextEl: '.swiper-hightlights .swiper-button-next',
        prevEl: '.swiper-hightlights .swiper-button-prev',
      },
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nascr-videos"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    const swiper = new Swiper('.swiper-nascr-videos', {
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1.8,
          spaceBetween: 10
        },
        // when window width is >= 480px
        769: {
          slidesPerView: 4,
          spaceBetween: 10
        }
      },
      navigation: {
        nextEl: '.swiper-nascr-videos .swiper-button-next',
        prevEl: '.swiper-nascr-videos .swiper-button-prev',
      },
    })
  })
  $('.swiper-nascr-videos .swiper-slide').each(function() {
    var $video = $(this).find('.nascr-video-item');
    var $icon = $(this).find('.play-icon');
  
    $(this).on('click', function(e) {
      if ($video[0].paused) {
        $video[0].play();
        $icon.hide();
      } else {
        $video[0].pause();
        $icon.show();
      }
    });
  
    $video.on('ended', function() {
      $icon.show();
    });
});

  } catch(e) { console.error(e); }
})();
})();
